import { render, staticRenderFns } from "./WagtailPage.vue?vue&type=template&id=4f42a21f&scoped=true"
import script from "./WagtailPage.vue?vue&type=script&lang=js"
export * from "./WagtailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f42a21f",
  null
  
)

export default component.exports